import './google-auth-button.css';

export const LineDivider = () => {
  return (
    <div className="google-auth-button-divider-container">
      <div className="google-auth-button-divider" />
      <p className="google-auth-button-or">O</p>
      <div className="google-auth-button-divider" />
    </div>
  );
};
